export default function MultiTenancy() {
  return (
    <section className="w-full bg-white py-20 px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Text */}
          <div className="flex-1">
            <span className="w-12 h-12 flex items-center justify-center bg-[#e8600a]/10 rounded-xl mb-5">
              <i className="ri-layout-masonry-line text-[#e8600a] text-2xl"></i>
            </span>
            <h2 className="text-2xl font-bold text-[#1a1a2e] mb-4">İç İçe Çok Kiracılılık</h2>
            <p className="text-[#374151] text-base leading-relaxed mb-4">
              VergeIO, BT çevikliğini artırır. İç içe çok kiracılı sanal veri merkezlerini anında oluşturun, taşıyın, ölçeklendirin ve klonlayın.
            </p>
            <p className="text-[#374151] text-base leading-relaxed mb-6">
              Bağımsız, güvenli, iç içe sanal veri merkezleri oluşturun. Her sanal veri merkezinin kendi uyumluluk standartları olabilir; şablondan klonlanabilir ve bir VergeIO platformundan diğerine taşınabilir. Uyumluluğu yönetmek, kanal veya geri ödeme yoluyla satmak için kiracılık özelliğini kullanın.
            </p>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-[#f8f9fb] rounded-lg px-4 py-2 text-sm text-[#374151]">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line text-[#e8600a] text-sm"></i>
                </span>
                Izole Ortamlar
              </div>
              <div className="flex items-center gap-2 bg-[#f8f9fb] rounded-lg px-4 py-2 text-sm text-[#374151]">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-exchange-line text-[#e8600a] text-sm"></i>
                </span>
                Kolay Taşınabilirlik
              </div>
              <div className="flex items-center gap-2 bg-[#f8f9fb] rounded-lg px-4 py-2 text-sm text-[#374151]">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-[#e8600a] text-sm"></i>
                </span>
                Uyumluluk Yönetimi
              </div>
            </div>
          </div>

          {/* Diagram */}
          <div className="flex-1 flex justify-center">
            <div className="w-full max-w-[480px] h-[320px] rounded-xl overflow-hidden border border-gray-100 bg-[#f8f9fb] flex items-center justify-center">
              <img
                src="https://public.readdy.ai/ai/img_res/2379a06731df3df29705b33b10c2894d.jpg"
                alt="İç İçe Çok Kiracılılık Diyagramı"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
